<template>
  <div>
    <b-modal
      id="add-order-type"
      ref="modal"
      header-class="headerModal"
      centered
      :title="$t('AddOrderType')"
      hide-footer
      @close="onCancel"
    >
      <b-form>
        <b-form-group
          id="input-select-1"
          :label="$t('Name')"
          label-for="select-1"
        >
          <b-input
            v-model="$v.name.$model"
            :placeholder="$t('Write...')"
            :state="validateState('name')"
            aria-describedby="input-1-live-feedback"
            required
          />
        </b-form-group>
        <p
          v-if="this.$v.$error"
          style="color: red;"
        >
          {{ $t("Required") }}
        </p>
        <div class="buttonsEverywhere">
          <button
            type="button"
            variant="primary"
            class="buttonSubmit"
            style="margin-top: 10px;"

            @click="onSubmit"
          >
            {{ $t('Submit') }}
          </button>
          <b-button
            type="button"
            variant="danger"
            class="buttonCancel"
            style="margin-right: 15px; margin-top: 10px; background: white; color: black; border-color: white;font-weight: 400;"

            @click="onCancel"
          >
            {{ $t('Cancel') }}
          </b-button>
        </div>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { validationMixin } from 'vuelidate';
import {
  required,
}
from 'vuelidate/lib/validators';

export default {
  mixins: [validationMixin],
  props: [],
  data() {
    return {
      name: null,
    }
  },
  validations: {
    name: {
      required,
    },
  },
  computed: {
    ...mapGetters([]),
  },
  watch: {

  },
  mounted() {

  },
  methods: {
    ...mapActions([]),
    validateState(name) {
      const { $dirty, $error } = this.$v[name];
      return $dirty ? !$error : null;
    },
    onSubmit() {
      this.$v.$touch();
      if (this.$v.$anyError) {
        return;
      }
      this.$emit('addOrderTypes', this.name)
      this.$refs.modal.hide()
      setTimeout(() => {
        this.resetForm()
      }, 10)
    },
    onCancel() {
      this.$refs.modal.hide()
      this.resetForm()
    },
    resetForm() {
      this.name = null
      this.$nextTick(() => { this.$v.$reset() })
    },
  },
}
</script>

  <style lang="scss" scoped>
  </style>
